import React , {Component} from 'react';
import { Table, FormGroup, Label, Input } from 'reactstrap';

export default class GetCheckBox extends Component{
    constructor(props){
        super(props);
        this.state={
            checked:false
        }
    }

    componentDidMount(){
       let userDatachecked = (this.props.userdata && this.props.userdata.checked) ? true : false;
       this.setState({checked:userDatachecked})
    }

    componentWillReceiveProps(props){
        if (this.props.userdata && (this.props.userdata.checked !== this.state.checked)) {
            //console.log("GetCheckBox willreceive");
            let userDatachecked = (this.props.userdata && this.props.userdata.checked) ? true : false;
            this.setState({checked:userDatachecked}) 
        }
    }

    render(){
        let active = (this.props.active) ? "" : " disabled";
        //const userDatachecked = (this.props.userdata && this.props.userdata.checked) ? true : false;
        return(
        <div className="RegFunc singleCheck">
        <div className={"checkSelect"+active}>
        <FormGroup check>                            
        <Input type="checkbox" checked={this.state.checked} onChange={(()=>{
            if(typeof this.props.checkUnCheckUsers === "function"){
                this.props.checkUnCheckUsers.apply(this, [this.props.userdata, this]);
            }

            //console.log("clicked admin");
            if(typeof this.props.callBack==="function"){
                this.props.callBack.apply(this,[this.props.userdata]);      
                let checked = this.state.checked;
                this.setState({checked:!checked});    
                if(typeof this.props.userListCount==="function"){
                    this.props.userListCount()    
                }       
            };
        })} /><Label check>
        </Label>
        </FormGroup>
        </div>
        </div>
        );

    }
}


// WEBPACK FOOTER //
// ./src/views/registration/GetCheckBox.js